<template>
  <div class="content self_vipcard self_c">
    <headNav
      color="#56AC9A"
      :showScan="true"
      @rightClick="goScan"
    />
    <div class="self_b">
      <membershipCardOne
        :info_obj="info_obj"
        :qrcodeContent="window_.qrcodeContent"
      />

      <div class="self_lines"></div>

      <div
        class="cell-swiper-box self_cell-swiper-box"
        v-if="!isPc"
      >
        <!-- :autoplay="3000" -->
        <van-swipe
          :loop="false"
          :width="swiperOption.width"
          :height="swiperOption.heigth"
          :show-indicators="false"
        >
          <van-swipe-item
            style="padding-left: 10px;padding-right:10px;"
            v-for="(item, index) in swiperList"
            :key="index"
          >
            <div
              class="cell-item"
              @click="goAd(item.id)"
            >
              <van-image
                class="cell_swiper_img"
                fit="cover"
                style="width:100%;height:100%;"
                radius="10px"
                :src="item.adImage"
              >
                <template v-slot:loading>
                  <van-loading
                    type="spinner"
                    size="20"
                  />
                </template>
                <template v-slot:error>
                  <img
                    src="../../assets/icon/default.png"
                    style="width:100%;height:100%;border-radius: 10px;"
                  />
                </template>
              </van-image>
              <div
                v-if="item.adTitle"
                class="cell_swiper_text_mask ell1"
              >
                {{ item.adTitle }}
              </div>
              <p
                v-if="item.adTitle"
                class="cell_swiper_text ell1"
                v-text="item.adTitle"
              ></p>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <!-- pc 輪播 -->
      <div
        class="cell-swiper-box self_cell-swiper-box pc_cell-swiper-box"
        v-if="isPc"
      >
        <el-carousel
          :height="`${swiperOption.heigth}px`"
          :width="`${swiperOption.width}px`"
          :autoplay="false"
          indicator-position="none"
          arrow="always"
        >
          <el-carousel-item
            v-for="(item, index) in swiperList"
            :key="index"
          >
            <div
              class="cell-item"
              @click="goAd(item.id)"
            >
              <van-image
                class="cell_swiper_img"
                fit="cover"
                style="width:100%;height:100%;"
                radius="10px"
                :src="item.adImage"
              >
                <template v-slot:loading>
                  <van-loading
                    type="spinner"
                    size="20"
                  />
                </template>
                <template v-slot:error>
                  <img
                    src="../../assets/icon/default.png"
                    style="width:100%;height:100%;border-radius: 10px;"
                  />
                </template>
              </van-image>
              <div
                v-if="item.adTitle"
                class="cell_swiper_text_mask ell1"
              >
                {{ item.adTitle }}
              </div>
              <p
                v-if="item.adTitle"
                class="cell_swiper_text ell1"
                v-text="item.adTitle"
              ></p>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div
        v-if="1 == 2"
        class="body"
        :style="'height:' + window_.body_h + 'px;'"
      >
        <div
          class="head_bg"
          :style="'height:' + window_.head_bg_h + 'px;'"
        ></div>
        <div class="head_context">
          <div
            class="cell-box_bg"
            :style="
              'width:' +
                (window_.m_card_img_w + 40) +
                'px;top:' +
                window_.cell_box_bg_top +
                'px'
            "
            style="height: 76px;border-radius: 50%;"
          ></div>
          <van-image
            :src="
              info_obj.data.levelImgUrl
                ? info_obj.data.levelImgUrl
                : info_obj.data.brandImgUrl
            "
            :width="window_.m_card_img_w"
            :height="window_.m_card_img_h"
            radius="15"
            style="margin-top: 20px;"
          >
            <template v-slot:loading>
              <van-loading
                type="spinner"
                size="20"
              />
            </template>
            <template v-slot:error>
              <van-image
                class="errorImg"
                :src="require('../../assets/icon/default.png')"
              />
            </template>
          </van-image>
          <div
            class="cell_box"
            :style="'top:' + window_.m_card_bgtop + 'px;'"
          >
            <div
              class="cell_card_bgbox"
              style="box-shadow: rgb(180, 180, 180) 0vw 40px 20vw -40px, rgb(180, 180, 180) 0px 40px 40px -20vw, rgb(180, 180, 180) 0px 0px 0vw 0px, rgb(180, 180, 180) 0vw 40px 20vw -40px;"
              :style="'width:' + window_.cell_card_bgbox_w + 'px;'"
            >
              <div class="relative">
                <div
                  class="sjx_left_bg"
                  style="border-width: 25px 70px 25px 70px;top:-3px"
                  :style="
                    'border-right-width:' +
                      window_.cell_sjx_w +
                      'px;border-left-width:' +
                      window_.cell_sjx_w +
                      'px;'
                  "
                ></div>
                <div
                  class="sjx_left"
                  style="border-width: 25px 70px 25px 70px;"
                  :style="
                    'border-right-width:' +
                      window_.cell_sjx_w +
                      'px;border-left-width:' +
                      window_.cell_sjx_w +
                      'px;'
                  "
                ></div>
                <div
                  class="B-fdf1ce"
                  style="top: 47px;height: 3px;"
                ></div>
              </div>
              <div class="relative">
                <div
                  class="sjx_right_bg"
                  style="border-width: 25px 70px 25px 70px;top:-3px;"
                  :style="
                    'border-right-width:' +
                      window_.cell_sjx_w +
                      'px;border-left-width:' +
                      window_.cell_sjx_w +
                      'px;'
                  "
                ></div>
                <div
                  class="sjx_right"
                  style="border-width: 25px 70px 25px 70px;"
                  :style="
                    'border-right-width:' +
                      window_.cell_sjx_w +
                      'px;border-left-width:' +
                      window_.cell_sjx_w +
                      'px;'
                  "
                ></div>
                <div
                  class="B-fdf1ce"
                  style="top: 47px;height: 3px;"
                ></div>
              </div>

              <div
                class="qrcode_"
                v-show="qrcodeShowFlag"
                style="top: 5px;right: 45px;"
              >
                <img
                  v-if="window_.qrcodeImg"
                  :src="window_.qrcodeImg"
                  @click="window_.qrcodeShow = true"
                  style="width: 71px;height: 71px;border-radius: 5px;"
                />
                <div
                  v-else
                  id="qrcode_min"
                  @click="window_.qrcodeShow = true"
                  style="width: 71px;height: 71px;border-radius: 5px;padding: 5px;"
                ></div>
              </div>
              <div
                class="cell_card_content"
                style="margin-top: 50px;"
              >
                <div class="cell_name">{{ info_obj.data.levelName1 }}</div>
                <div class="cell_date">
                  <span v-if="info_obj.data3.menberUpgradeDate">{{
                    info_obj.data3.menberUpgradeDate
                  }}</span>
                  <span v-if="
                      info_obj.data3.menberUpgradeDate && info_obj.data3.endDate
                    ">-</span>
                  <span v-if="info_obj.data3.endDate">{{
                    info_obj.data3.endDate
                  }}</span>
                </div>
                <!-- 會員升級區域 -->
                <div
                  class="cell-level-box"
                  v-show="init_Height()"
                >
                  <!-- 舊等級 -->
                  <div class="cell-level self_cell-level">
                    <img
                      src="../../assets/huiyuan.png"
                      alt
                    />
                    <!-- <p class="cell-text">LV1</p> -->
                  </div>
                  <!-- 進度條 -->
                  <div class="cell-progress">
                    <!-- 當前值 -->
                    <van-progress
                      color="#c9af7c"
                      pivot-color="#c9af7c"
                      :show-pivot="true"
                      :percentage="
                        (info_obj.data1.nowPrice / info_obj.data3.countPrice) *
                        100
                          ? (info_obj.data1.nowPrice /
                              info_obj.data3.countPrice) *
                              100 >
                            100
                            ? 100
                            : (info_obj.data1.nowPrice /
                                info_obj.data3.countPrice) *
                              100
                          : 0
                      "
                      :pivot-text="String(info_obj.data1.nowPrice)"
                      stroke-width="5"
                      style="height: 6px;;"
                    />
                    <!-- 比值 -->
                    <div
                      class="cell-rate"
                      v-text="
                        info_obj.data1.nowPrice +
                          '/' +
                          info_obj.data3.countPrice
                      "
                    ></div>
                  </div>
                  <!-- 新等級 -->
                  <div class="cell-level self_cell-level">
                    <img
                      src="../../assets/huiyuan2.png"
                      alt
                    />
                    <!-- <p class="cell-text cell-text2">LV2</p> -->
                  </div>
                </div>
                <!-- 提示 -->
                <!-- :text="info_obj.data.levelDesc" -->
                <!-- <van-notice-bar v-if="info_obj.data.levelDesc" class="cell-hint" background="#fff" color="#c9af7c"  > -->
                <div v-html="info_obj.data.levelDesc"></div>
                <!-- </van-notice-bar> -->
                <div class="cell-section self_cell-section">
                  <div
                    @click="goIntegral"
                    class="cell-div"
                  >
                    <img
                      src="../../assets/jifen.png"
                      alt
                    />
                    <p>
                      {{ window_c["There are 2"] }}&nbsp;
                      <span v-text="info_obj.data.consumePoints"></span>
                      &nbsp;{{ window_c["points"] }}
                    </p>
                  </div>
                  <div class="cell-line"></div>
                  <div
                    @click="goCoupon"
                    class="cell-div"
                  >
                    <img
                      src="../../assets/youhuiquan.png"
                      alt
                    />
                    <p>
                      {{ window_c["There are 1"] }}&nbsp;
                      <span v-text="info_obj.data.couponCount"></span>
                      &nbsp;{{ window_c["coupons"] }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- 輪播 -->
            <div class="cell-swiper-box self_cell-swiper-box">
              <!-- :autoplay="3000" -->
              <van-swipe
                :loop="false"
                :width="swiperOption.width"
                :height="swiperOption.heigth"
                :show-indicators="false"
              >
                <van-swipe-item
                  style="padding-left: 10px;padding-right:10px;"
                  v-for="(item, index) in swiperList"
                  :key="index"
                >
                  <div
                    class="cell-item"
                    @click="goAd(item.id)"
                  >
                    <van-image
                      class="cell_swiper_img"
                      fit="cover"
                      style="width:100%;height:100%;"
                      radius="10px"
                      :src="item.adImage"
                    >
                      <template v-slot:loading>
                        <van-loading
                          type="spinner"
                          size="20"
                        />
                      </template>
                      <template v-slot:error>
                        <img
                          src="../../assets/icon/default.png"
                          style="width:100%;height:100%;border-radius: 10px;"
                        />
                      </template>
                    </van-image>
                    <div
                      v-if="item.adTitle"
                      class="cell_swiper_text_mask ell1"
                    >
                      {{ item.adTitle }}
                    </div>
                    <p
                      v-if="item.adTitle"
                      class="cell_swiper_text ell1"
                      v-text="item.adTitle"
                    ></p>
                  </div>
                </van-swipe-item>
              </van-swipe>
            </div>
          </div>
        </div>
      </div>
      <!-- 二維碼大圖 -->
      <div
        class="qrcodeMax_box"
        v-show="window_.qrcodeShow"
      >
        <van-overlay
          :show="window_.qrcodeShow"
          @click="window_.qrcodeShow = false"
        />
        <div
          class="qr_box_b"
          :style="
            'width:' + window_.qrcodeW + 'px;height:' + window_.qrcodeW + 'px;'
          "
        >
          <img
            v-if="window_.qrcodeImg"
            :src="window_.qrcodeImg"
            class="qrcode_max"
            :style="
              'width:' +
                window_.qrcodeW +
                'px;height:' +
                window_.qrcodeW +
                'px;'
            "
            style="padding: 4px;"
          />
          <div
            v-else
            id="qrcode_max"
            class="qrcode_max"
            :style="
              'width:' +
                window_.qrcodeW +
                'px;height:' +
                window_.qrcodeW +
                'px;'
            "
            style="padding: 4px;"
          ></div>
          <img
            src="../../assets/icon/icon_close.png"
            @click="window_.qrcodeShow = false"
            style="width:50px;height:50px;bottom: -60px;"
          />
        </div>
      </div>
      <!-- 通知第三方 已經登錄.  -->
      <!-- <iframe :src="thUrl" style="display: none;"></iframe> -->
    </div>
    <!-- 優惠券 -->
    <couponExchangeSuccess
      :img="change.img"
      :show="change.show"
      :data="change.data"
      :typeOfTeam="2"
    />
    <!-- 扫码 -->
    <selfScan
      v-model="isScan"
      @scanResult="scanResult"
    />
    <!-- 掃碼 領取成功 -->
    <van-overlay
      :show="scanSuccess.show"
      class-name="scanSuccess-box"
      z-index="1000"
    >

      <div class="scanSuccess">
        <van-icon
          name="clear"
          class="hide"
          size="24"
          @click="scanSuccess.show = false"
        />
        <div class="title">你已獲得訂單!</div>
        <div class="cell">
          <div class="key">獲得積分：</div>
          <div class="value">+{{scanSuccess.pointsAddOut}}</div>
        </div>
        <div class="cell">
          <div class="key">總金額：</div>
          <div class="value">${{scanSuccess.billAmount}}</div>
        </div>
      </div>
    </van-overlay>

  </div>
</template>

<script>
import headNav from '@/components/headNav';
import 'swiper/dist/css/swiper.css';
import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper';
import couponExchangeSuccess from '@/components/couponExchangeSuccess';
import {
  getMemberInfoOth,
  getQuickMark,
  getByInvitedMemberIdOrBrandId,
  bindEncashQRcode
} from '@/js/api';
import membershipCardOne from '@/components/membershipCardOne';
import util from '@/js/util.js';
import QRCode from 'qrcodejs2';
import lang_ from '@/js/locales';
import selfScan from "@/components/scan";
export default {
  data () {
    return {
      isScan: false,
      scanSuccess: {
        show: false,
        pointsAddOut: '',
        billAmount: ''
      },
      window_: {
        head_bg_h: 0,
        body_h: 0,
        m_card_img_w: 0,
        m_card_img_h: 0,
        m_card_bgtop: 0,
        cell_box_bg_top: 0,
        cell_card_bgbox_w: 0,
        cell_card_bgbox_h: 0,
        cell_sjx_w: 0,
        qrcodeShow: false,
        qrcodeW: 0,
        qrcodeImg: "",
        qrcodeContent: ""
      },
      window_c: {
        "There are 1": "優惠券",
        coupons: "張",
        "There are 2": "積分",
        points: "分",
        Loading: "加載中..."
      },
      swiperList: [],
      info_obj: {
        data: {
          levelName1: "",
          consumePoints: 0,
          couponCount: 0,
          levelDesc: "",
          brandImgUrl: ""
        },
        data1: {
          nowPrice: 0
        },
        data2: {},
        data3: {
          countPrices: 0,
          countPrice: 0,
          menberUpgradeDate: "",
          endDate: ""
        },
        data4: {}
      },
      swiperOption: {
        slidesPerView: 2, // 一行顯示幾個
        centeredSlides: true, // 默认active slide居左，设置为true后居中
        spaceBetween: 20, // 輪播之間的間距
        slideToClickedSlide: true, // 點擊會居中
        width: 0,
        heigth: 0
      },
      thUrl: "",
      qrcodeShowFlag: false,
      isPc: false,
      userInfo: {},
      change: {
        img: '',
        show: false,
        data: []
      }
    };
  },
  created () {
    util.selfSetIcon(); // 設置logo
    this.init_lang();
    this.init_window();
    util.getBrand(this, () => {
      this.getMemberInfo();
      this.getQuickMark_();
    });
  },
  methods: {
    init_window () {
      let J = util.getWindowInner();
      let w = J.w,
        h = J.h;
      let isPc = util.IsPC();
      this.window_.qrcodeW = w / 1.5;
      this.window_.cell_bg_h = w / 1.65;
      this.swiperOption.width = w * 0.8;
      this.swiperOption.heigth = (w * 0.8) / 2;
      this.window_.head_h = (w * 0.9) / 1.2 + 133;
      if (isPc) {
        this.isPc = isPc;
        this.swiperOption.width = w - 20;
        this.swiperOption.heigth = (w - 20) / 2;
      }
      this.window_.head_bg_h = w / 1.65; //1.65 原圖比
      this.window_.body_h = h - 96;
      this.window_.m_card_img_w = w - 70; //70 表示 左右邊距之和
      this.window_.m_card_img_h = (window.innerWidth - 70) / 1.73; // 1.73 會員卡圖片 比
      this.window_.m_card_bgtop = this.window_.m_card_img_h / 2 + 66; // 會員卡圖片高/ 2 + 66的邊距
      this.window_.cell_box_bg_top = this.window_.m_card_bgtop - 38;
      this.window_.cell_card_bgbox_w = this.window_.m_card_img_w + 40;
      this.window_.cell_card_bgbox_h = this.window_.cell_card_bgbox_w / 1.2;
      this.window_.cell_sjx_w = this.window_.cell_card_bgbox_w / 4;

      // 檢測是否是首次登陸或註冊.
      // if(localStorage.isloginflag == 'ilogin' && localStorage.foodStoryLoginT == true) {
      // 	this.thUrl = 'http://thefoods.bspassion.com/index.php?token=' + encodeURI(localStorage.userinfo);
      // 	localStorage.isloginflag = '';
      // }
    },
    init_lang () {
      var window_c = this.window_c;
      window_c["There are 1"] = lang_.t("There are 1");
      window_c["coupons"] = lang_.t("coupons");
      window_c["There are 2"] = lang_.t("There are 2");
      window_c["points"] = lang_.t("points");
      window_c["Loading"] = lang_.t("Loading");
    },
    goIntegral () {
      // 积分
      sessionStorage.setItem("consumePoints", this.info_obj.data.consumePoints);
      this.$router.push({
        // path: '/integral/' + this.info_obj.data.consumePoints
        name: "integral",
        params: {
          arg: this.$route.params.arg
        }
      });
    },
    goCoupon () {
      // 优惠卷
      this.$router.push({
        name: "my_coupon",
        params: {
          arg: this.$route.params.arg
        }
      });
    },
    goAd (e) {
      this.$router.push({
        name: "ad",
        params: {
          arg: util.setQueryParams([util.getBrandId(this), e])
        }
      });
    },
    getMemberInfo () {
      var self = this;
      let userInfoStr = util.userInfo.get(this)
      if (userInfoStr) {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: self.window_c["Loading"]
        });
        var userinfo = JSON.parse(userInfoStr);
        var data = {
          brandId: util.getBrandId(this),
          memberId: userinfo.memberId,
          phone: userinfo.phone
        };
        getMemberInfoOth(data).then(res => {
          console.log(res);
          self.$toast.clear();
          if (res.code == "1") {
            this.swiperList = res.data.advertisement;
            localStorage.brandMemberInfoIcon = res.data.brandMemberInfoIcon;
            for (const key in this.info_obj) {
              this.info_obj[key] = res[key];
            }
            this.userInfo = userinfo;
            this.getByInvitedMemberIdOrBrandId();
          }
        });
      }
    },
    getQuickMark_ () {
      var self = this;
      let userInfoStr = util.userInfo.get(this)
      if (userInfoStr) {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: self.window_c["Loading"]
        });
        var userinfo = JSON.parse(userInfoStr);
        var data = {
          memberId: userinfo.memberId,
          type: 1
        };
        getQuickMark(data).then(res => {
          self.$toast.clear();
          console.log("獲取二維碼數據", res);
          if (res.code == 1) {
            if (res.qrcode) {
              self.window_.qrcodeContent = res.qrcode;
            }
            // if (res.quickMark) {
            //   self.window_.qrcodeImg = res.quickMark;
            //   self.qrcodeShowFlag = true;
            // } else {
            //   self.canvasQrcode(res.qrcode);
            //   self.qrcodeShowFlag = true;
            // }
          }
        });
      }
    },
    errorImg (img) {
      return util.errorImg(img);
    },
    canvasQrcode (val) {
      var self = this;
      new QRCode("qrcode_min", {
        width: 61,
        height: 61,
        text: val, //表示内容，可以是地址或者是文字'55566'或者参数
        colorDark: "#000000", //前景色
        colorLight: "#ffffff" //背景色
      });

      new QRCode("qrcode_max", {
        width: self.window_.qrcodeW - 10,
        height: self.window_.qrcodeW - 10,
        text: val, //表示内容，可以是地址或者是文字'55566'或者参数
        colorDark: "#000000", //前景色
        colorLight: "#ffffff" //背景色
      });
    },
    init_Height () {
      // var self = this;
      // if (this.info_obj.data1.nowPrice >= this.info_obj.data3.countPrice) {
      // 	self.window_.head_h = document.getElementsByClassName('cell-box')[0].clientHeight + 143 - document.getElementsByClassName('cell-level-box')[0].clientHeight;
      // 	return true;
      // }
      return true;
    },
    // 查詢用戶 未讀券
    getByInvitedMemberIdOrBrandId () {
      getByInvitedMemberIdOrBrandId({
        invitedMemberId: this.userInfo.memberId,
        brandId: util.getBrandId(this)
      }).then(res => {
        console.log(res);
        if (res.success) {
          this.change.img = res.data.imgUrl;
          let data = res.data;
          if (data && data.length > 0) {

            data.forEach(item => {
              item.startTime = item.couponCreateTime || '';
              item.endTime = item.couponEndTime || '';
              item.select = true;
            });

            // if (res.data[0].isRead == 0) {
            this.change.data = data;
            this.change.show = true;
            // }
          }

        }
      })
    },
    goScan () {
      this.isScan = true;
    },
    scanResult (data) {
      console.log(data);
      if (data) {
        let json = {};
        try {
          this.$toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: this.window_c["Loading"]
          });
          data = decodeURIComponent(data)
          json = JSON.parse(data.substring(data.indexOf('{')))
          bindEncashQRcode({
            memberId: this.userInfo.memberId,
            data: json.data
          }).then(res => {
            this.$toast.clear();
            if (res.code == '1') {
              let data = res.data;
              this.scanSuccess.pointsAddOut = data.pointsAddOut || 0;
              this.scanSuccess.billAmount = data.billAmount || 0;
              this.scanSuccess.show = true;
            } else {
              this.$toast(res.errorMsg || '綁定失敗,請檢查二維碼後重試!');
            }
          })
        } catch (error) {
          this.$toast.clear();
          this.$toast('無效二維碼');
        }
      } else {
        this.$toast('無效二維碼');
      }

    }
  },
  components: {
    membershipCardOne,
    headNav,
    swiper,
    swiperSlide,
    couponExchangeSuccess,
    selfScan
  }
};
</script>

<style scoped lang="less">
.body {
  background-color: #ffffff;
}

.B-fdf1ce {
  background-color: #fdf1ce;
  position: absolute;

  width: 100%;

  z-index: 0;
}

.head_bg {
  position: absolute;
  background-image: linear-gradient(#717171, #d4d4d4);
  top: 0;
  width: 100%;
}

.errorImg {
  width: 100%;
  height: 100%;
}

.head_context {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cell-box_bg {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  /* z-index: 1; */
  background-color: rgb(135, 134, 134);
}

.cell_box {
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.cell_card_bgbox {
  align-self: center;
  display: flex;
  flex-wrap: wrap;
}

.sjx_left {
  width: 0;
  height: 0;
  border-style: solid;
  border-color: transparent transparent #fff #fff;
  position: absolute;
  z-index: 1;
}

.sjx_left_bg {
  width: 0;
  height: 0;
  border-style: solid;
  border-color: transparent transparent #fdf1ce #fdf1ce;
  position: absolute;
  z-index: 1;
}

.sjx_right {
  width: 0;
  height: 0;
  border-style: solid;
  border-color: transparent #fff #fff transparent;
  position: absolute;
  z-index: 1;
}

.sjx_right_bg {
  width: 0;
  height: 0;
  border-style: solid;
  border-color: transparent #fdf1ce #fdf1ce transparent;
  position: absolute;
  z-index: 1;
}

.cell_card_content {
  background-color: #ffffff;
  width: 100%;
  padding: 3.2vw;
  padding-top: 0;
}

.cell_name {
  background-image: -webkit-linear-gradient(bottom, #9e834c, #b69d6b, #cbbd9e);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 1.333vw;
  font-size: 4.267vw;
}

.cell_date {
  color: #999;
  font-size: 3.2vw;
}

.cell-level-box {
  display: flex;
  /* align-items: flex-start; */
  align-items: center;
  margin-bottom: 10px;
}

.cell-progress {
  position: relative;
  flex: 1;
  margin: 0 10px;
  padding-top: 50px;
  /* box-sizing: border-box; */
}

.cell-rate {
  margin-top: 10px;
  font-size: 20px;
  color: #666;
  text-align: right;
}

.cell-level {
  text-align: center;
  display: flex;
  align-items: center;
}

.self_cell-level img {
  width: 30px;
  height: 30px;
  /* margin-bottom: -5px; */
}

.cell-hint {
  font-size: 24px;
}

.cell-section {
  display: flex;
  align-items: center;
  justify-content: center;
}

.cell-div {
  flex: 1;
  text-align: center;
}

.cell-div img {
  width: 56px;
  height: 56px;
}

.cell-div p {
  font-size: 24px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cell-div span {
  font-size: 30px;
  color: #56ac9a;
}

.cell-line {
  height: 60px;
  border-right: 1px solid #ccc;
}

.cell-swiper-box {
  position: relative;
  z-index: 3;
  background-color: #fff;
}

.self_cell-swiper-box {
  padding: 10px 0;
  margin-top: 10px;
  margin-bottom: 50px;
}

.pc_cell-swiper-box {
  padding: 10px;
}

.cell-swiper-box swiper {
  padding-bottom: 5px;
}

.cell-swiper {
  width: 100%;
  display: flex;
  background-color: #fff;
  padding: 30px;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}

.cell-swiper::-webkit-scrollbar {
  display: none;
}

.cell-item {
  position: relative;
  border-radius: 20px;
  box-shadow: 0 0 8px #c9af7c;
  background: url() no-repeat center center;
  background-size: cover;
  width: 100%;
  height: 100%;
}

.cell_swiper_text_mask {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  font-size: 16px;
  border-radius: 0 0 20px 20px;
  padding: 10px 0 10px 6px;
  background-color: rgba(183, 151, 97, 0.8);
  opacity: 0.5;
}

.cell_swiper_text {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  font-size: 16px;
  color: #fff;
  padding: 10px 0 10px 6px;
}

.cell-adTitle {
  position: absolute;
  width: 60%;
  bottom: 0;
  left: 0;
  padding: 30px 0 30px 20px;
}

.cell_swiper_img {
  width: 100%;
  height: 100%;
  border-radius: 20px;
}

.qrcode_ {
  position: absolute;
  z-index: 3;
}

.qrcodeMax_box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
}

.qr_box_b {
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
}

.qrcodeMax_box img {
  position: absolute;
  z-index: 3;
}

.qrcode_max {
  position: absolute;
  background-color: #fff;
  border: 1px solid #979797;
  z-index: 2;
}

#qrcode_min {
  background-color: #fff;
}

.relative {
  position: relative;
  width: 50%;
}

.self_cell-section {
  margin-top: 10px;
}

.self_lines {
  height: 8px;
  background: #e8e8e8;
}

.scanSuccess-box {
  display: flex;
  align-items: center;
  justify-content: center;
  .scanSuccess {
    padding: 30px 20px 20px;
    background-color: #fff;
    width: 70%;
    border-radius: 8px;
    position: relative;
    .hide {
      position: absolute;
      right: 8px;
      top: 8px;
      color: gray;
    }
    .title {
      font-size: 18px;
      text-align: center;
    }
    .cell {
      display: flex;
      margin: 10px 0;
      align-items: center;
      justify-content: center;
      .key {
        font-size: 14px;
      }
      .value {
        font-size: 24px;
        color: red;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/vipCard/index.vue